import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './iosdata.routes';
import addHtml from './modal/add.html';




export class IosDataController {
    $http;
    socket;
    awesomeThings = [];
    awesomeUsers = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location, $timeout) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;
        this.$timeout = $timeout;

    }



    $onInit() {



    }




    // app.use('/api/download_date', require('./api/download_date'));
    // app.use('/api/complete_task_date', require('./api/complete_task_date'));
    taskExcel() {
        this.$http.get('/api/complete_task_date/?mark=1', {}).then((response) => {
            if (response.status === 200) {
                console.log(response.data.data);
                this.$timeout(window.open('https://www.bibliagratis.mobi' + response.data.data, "_blank"), 5000)
            }
        }, (error) => {
            console.log(error);
        });
    }

    exprotExcel() {
        this.$http.get('/api/complete_task_date/?mark=2', {}).then((response) => {
            if (response.status === 200) {
                console.log(response.data.data);
                this.$timeout(window.open('https://www.bibliagratis.mobi' + response.data.data, "_blank"), 5000)
            }
        }, (error) => {
            console.log(error);
        });
    }

    payExcel() {
        this.$http.get('/api/complete_task_date/?mark=3', {}).then((response) => {
            if (response.status === 200) {
                console.log(response.data.data);
                this.$timeout(window.open('https://www.bibliagratis.mobi' + response.data.data, "_blank"), 5000)
            }
        }, (error) => {
            console.log(error);
        });
    }





}

export default angular.module('tttApp.iosdata', [uiRouter])
    .config(routing)
    .component('iosdata', {
        template: require('./iosdata.html'),
        controller: IosDataController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/iosdata/iosdata.component.js